import { useSnapshot } from "valtio"
import { configStore } from "../state/CommonState"
import { myactionsstore } from "./store-myactions"
import { OneDatetable, OneInput5table } from "../mytasks/act-common"
import { ServerLists } from "../StaticData"
import { useForm } from 'react-hook-form';
import Api from "../state/Api";
import { useEffect, useState } from "react"
import Utils from "../util/Utils";

export function CustomModal(props) {
    useSnapshot(myactionsstore)
    useSnapshot(configStore)
    let ret = props?.data
    console.log(props);
    const [exportClearance, setExportClearance] = useState([])
    const [importClearance, setImportClearance] = useState([])
    const [icegateData, seticegateData] = useState(null)
    const { register, handleSubmit, errors } = useForm();
    const [exportClearancekeys, setExportClearancekeys] = useState([])  

    const exportIndia = [{
        label: "Shipping Bill Checklist",
        value: ""
    }, {
        label: "Shipping Bill Number",
        value: ""
    }, {
        label: "Shipping Bill Date",
        value: ""
    }, {
        label: "Let-Export-Order Date",
        value: ""
    }]

    const exportNonIndia = [{
        label: "Customs Entry",
        value: ""
    }, {
        label: "Customs Reference Number",
        value: ""
    }, {
        label: "Submission to Customs Date",
        value: ""
    }, {
        label: "Cleared for export",
        value: ""
    }]

    const importIndia = [{
        label: "Bill of Entry Checklist",
        value: ""
    }, {
        label: "Bill of Entry Number",
        value: ""
    }, {
        label: "Bill of Entry Date",
        value:  ""
    }, {
        label: "Out of Charge Date",
        value: ""
    }]

    const importNonIndia = [{
        label: "Customs Entry",
        value: ""
    }, {
        label: "Customs Reference Number",
        value: ""
    }, {
        label: "Submission to Customs Date",
        value: ""
    }, {
        label: "Customs Clearance Complete",
        value: ""
    }]
   async function getData() {
        await Api.getICEGATEData({id:configStore.modalvisibledata?._id || props.data?._id},async(data)=>{
            console.log(data?.data);
            let resData = data?.data
            if (resData?.length > 0 && resData[0]?.icegateResData) {
                let tempData = {
                    res:resData[0]?.icegateResData?.response,
                    req:resData[0]?.icegateReqData,
                    customerCompletedOn:Utils.convertEpochDate(resData[0]?.customerCompletedOn)?.split(',')[0],
                    fullDate:Utils.convertEpochDate(resData[0]?.customerCompletedOn)
                }
                seticegateData(tempData)
               const date=  Utils.convertEpochDate(resData[0]?.customerCompletedOn)
               console.log(date.split(',')[0]);
            } else seticegateData(null)
        })
    } 

    useEffect(() => {
        getData()
    },[props?.data]);
    useEffect(() => {
        const exportClearancevalue = ()=>{
            let k = props?.data
            let exportKeys = Object.keys(k).filter(key => key.startsWith("exportClearance"));
            let exportValues = [];
            if (exportKeys.length > 0) {
            exportValues = exportKeys
                .sort((a, b) => {
                let numA = a.match(/\d+$/);
                let numB = b.match(/\d+$/);
                numA = numA ? parseInt(numA[0]) : 1;
                numB = numB ? parseInt(numB[0]) : 1;
                return numA - numB;
                })
                .map(key => k[key]);
            }
            return exportValues
        }
        if (Utils.extractCountry(ret?.booking?.contract?.portOfReceipt).toLowerCase() == 'india') {
            let ec = exportClearancevalue()
            let k = ec.length>0 ? ec : [exportIndia]
            setExportClearance(k)
            setExportClearancekeys(["Shipping Bill Checklist","Shipping Bill Number","Shipping Bill Date","Let-Export-Order Date"])
        }
        if (Utils.extractCountry(ret?.booking?.contract?.finalPlaceOfDelivery).toLowerCase() === 'india') {
            setImportClearance(props?.data?.importClearance?.length>0 ? props?.data?.importClearance : importIndia)
        }
        if (Utils.extractCountry(ret?.booking?.contract?.finalPlaceOfDelivery).toLowerCase() !== 'india') {
            setImportClearance(props?.data?.importClearance?.length>0 ? props?.data?.importClearance : importNonIndia)
        }
        if (Utils.extractCountry(ret?.booking?.contract?.portOfReceipt).toLowerCase() !== 'india') {
            let ec = exportClearancevalue()
            let k = ec.length>0 ? ec : [exportNonIndia]
            setExportClearance(k)
            setExportClearancekeys(["Customs Entry","Customs Reference Number","Submission to Customs Date","Cleared for export"])
        }
    }, [props?.data]);

    let modalClass = 'modal'
    if (props.open) modalClass += ' is-active'

    const onSubmit = () => {
            for (let i = 0; i < exportClearance.length; i++) {
                let l = i+1
                if(l==1){
                    ret.exportClearance = exportClearance[i]
                }else{
                    ret["exportClearance"+l] = exportClearance[i]
                }
            }
            ret.importClearance = importClearance
            configStore.modalvisibledata = ret
        props.close()
    }
    return (
        <>
            {
                exportClearance.length>0 && <div className={modalClass}>
                    <div className="modal-background" ></div>
                    <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px', width: "75%" }} >
                        <div className="modal-card-body" >
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                                <div style={{ backgroundColor: "grey", color: "white", height: "25px", width: "25px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", cursor: 'pointer' }} onClick={props.close}>X</div>
                            </div>
                            <div className="table-container" onClick={(e) => e.stopPropagation()}>
                                <div style={{ paddingBottom: '20px', fontWeight: 'bold' }}>Export Clearance ({Utils.extractCountry(props.data?.booking?.contract?.portOfReceipt)})</div>
                                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                                    <thead>
                                        <tr>
                                            {exportClearancekeys.map((e) => <th>{e}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            exportClearance?.map((ec,i)=>(
                                            <tr>
                                            {ec?.map((e, index) => (
                                                <>{exportClearancekeys.indexOf(e.label)!=-1 && <td key={index}>
                                                    {
                                                        (e.label === "Let-Export-Order Date")?<>
                                                        <div className="control is-fullwidth is-small" style={{ display: 'flex', gap: '4px' }}>
                                                                <input
                                                                  type="date"
                                                                  className="input is-small"
                                                                  max={Utils.dateConversion(new Date(), true)}
                                                                  onKeyDown={(e) => e.preventDefault()} 
                                                                  disabled={icegateData && (e.label === "Shipping Bill Date"|| (icegateData && icegateData?.res?.leoDt?.length > 4 && e.label === "Let-Export-Order Date")|| e.label === "Shipping Bill Checklist")?true:props.disable}
                                                                  value={
                                                                      icegateData && e.label === "Shipping Bill Checklist"?exportClearance[i][index].value=`${icegateData?.customerCompletedOn.replace(/\//g, '-').split('-').reverse().join('-')}`:
                                                                      icegateData && e.label === "Shipping Bill Date"?exportClearance[i][index].value=`${icegateData?.req?.date?.slice(4, 8)}-${icegateData?.req?.date?.slice(2, 4)}-${icegateData?.req?.date?.slice(0, 2)}`:
                                                                      (icegateData && icegateData?.res?.leoDt?.length > 4 && e.label === "Let-Export-Order Date")?exportClearance[i][index].value=`${icegateData?.res?.leoDt?.slice(4, 8)}-${icegateData.res?.leoDt?.slice(2, 4)}-${icegateData.res?.leoDt?.slice(0, 2)}`:exportClearance[i][index]?.value?.split('T')[0]
                                                                  }
                                                                  onChange={(e) => {
                                                                    setExportClearance((prev) => {
                                                                        const updatedDocumentList = [...prev];
                                                                        updatedDocumentList[i][index].value = e.target.value
                                                                        return updatedDocumentList
                                                                    })
                                                                  }}
                                                                />
                                                                <input
                                                                  type="time"
                                                                  className="input is-small"
                                                               onKeyDown={(e) => e.preventDefault()} 
                                                                  disabled={icegateData && (e.label === "Shipping Bill Date"|| (icegateData && icegateData?.res?.leoDt?.length > 4 && e.label === "Let-Export-Order Date")|| e.label === "Shipping Bill Checklist")?true:props.disable}
                                                                  value={
                                                                      icegateData && e.label === "Shipping Bill Checklist"?exportClearance[i][index].value=`${icegateData?.customerCompletedOn.replace(/\//g, '-').split('-').reverse().join('-')}`:
                                                                      icegateData && e.label === "Shipping Bill Date"?exportClearance[i][index].value=`${icegateData?.req?.date?.slice(4, 8)}-${icegateData?.req?.date?.slice(2, 4)}-${icegateData?.req?.date?.slice(0, 2)}`:
                                                                      (icegateData && icegateData?.res?.leoDt?.length > 4 && e.label === "Let-Export-Order Date")?exportClearance[i][index].value=`${icegateData?.res?.leoDt?.slice(4, 8)}-${icegateData.res?.leoDt?.slice(2, 4)}-${icegateData.res?.leoDt?.slice(0, 2)}`:exportClearance[i][index]?.value?.split('T')[1]
                                                                  }
                                                                  onChange={(e) => {
                                                                    const time = e.target.value;
                                                                    const existingDate = exportClearance[i][index].value?.split('T')[0] ;
                                                                    if(existingDate){
                                                                       setExportClearance((prev) => {
                                                                           const updatedDocumentList = [...prev];
                                                                           updatedDocumentList[i][index].value = `${existingDate}T${time}`
                                                                           return updatedDocumentList
                                                                       })
                                                                    } 
                                                                  }}
                                                                />
                                                          </div>
                                                        {/* <input
                                                            className="input is-normal"
                                                            type="datetime-local"
                                                            max={Utils.dateConversion(new Date(), true)}
                                                            onKeyDown={(e) => e.preventDefault()} 
                                                            disabled={icegateData && (e.label === "Shipping Bill Date"||e.label === "Let-Export-Order Date" || e.label === "Shipping Bill Checklist")?true:props.disable}
                                                            value={
                                                                icegateData && e.label === "Shipping Bill Checklist"?exportClearance[i][index].value=`${icegateData?.customerCompletedOn.replace(/\//g, '-').split('-').reverse().join('-')}`:
                                                                icegateData && e.label === "Shipping Bill Date"?exportClearance[i][index].value=`${icegateData?.req?.date?.slice(4, 8)}-${icegateData?.req?.date?.slice(2, 4)}-${icegateData?.req?.date?.slice(0, 2)}`:
                                                                icegateData && e.label === "Let-Export-Order Date"?exportClearance[i][index].value=`${icegateData?.res?.leoDt?.slice(4, 8)}-${icegateData.res?.leoDt?.slice(2, 4)}-${icegateData.res?.leoDt?.slice(0, 2)}T00:00`:exportClearance[i][index].value
                                                            }
                                                            placeholder="Enter a Number"
                                                            onChange={(e) => {
                                                                // const today = new Date().toISOString().split('T')[0];
                                                                // const selectedDate = e.target.value;
                                                                // if (selectedDate <= today) {
                                                                    setExportClearance((prev) => {
                                                                        const updatedDocumentList = [...prev];
                                                                        updatedDocumentList[i][index].value = e.target.value
                                                                        return updatedDocumentList
                                                                    })
                                                                // } else {
                                                                //     configStore.setModalMessage("Enter a valid date")
                                                                // }
                                                            }}
                                                        /> */}
                                                        </>:<>
                                                        {index === 1 ? (
                                                        <input
                                                            className="input is-normal"
                                                            type="text"
                                                            disabled={icegateData && (e.label === "Shipping Bill Number")?true:props.disable}
                                                            value={icegateData && e.label === "Shipping Bill Number"?exportClearance[i][index].value=icegateData?.req?.no:exportClearance[i][index].value}
                                                            onChange={(e) => {
                                                                setExportClearance((prev) => {
                                                                    const updatedDocumentList = [...prev];
                                                                    updatedDocumentList[i][index].value = e.target.value
                                                                    return updatedDocumentList
                                                                })
                                                            }}
                                                        />
                                                    ) : (
                                                        <>
                                                        <input
                                                            className="input is-normal"
                                                            type="date"
                                                            max={Utils.dateConversion(new Date(), true)}
                                                            onKeyDown={(e) => e.preventDefault()} 
                                                            disabled={icegateData && (e.label === "Shipping Bill Date"|| (icegateData && icegateData?.res?.leoDt?.length > 4 && e.label === "Let-Export-Order Date")|| e.label === "Shipping Bill Checklist")?true:props.disable}
                                                            value={
                                                                icegateData && e.label === "Shipping Bill Checklist"?exportClearance[i][index].value=`${icegateData?.customerCompletedOn.replace(/\//g, '-').split('-').reverse().join('-')}`:
                                                                icegateData && e.label === "Shipping Bill Date"?exportClearance[i][index].value=`${icegateData?.req?.date?.slice(4, 8)}-${icegateData?.req?.date?.slice(2, 4)}-${icegateData?.req?.date?.slice(0, 2)}`:
                                                                (icegateData && icegateData?.res?.leoDt?.length > 4 && e.label === "Let-Export-Order Date")?exportClearance[i][index].value=`${icegateData?.res?.leoDt?.slice(4, 8)}-${icegateData.res?.leoDt?.slice(2, 4)}-${icegateData.res?.leoDt?.slice(0, 2)}`:exportClearance[i][index].value
                                                            }
                                                            placeholder="Enter a Number"
                                                            onChange={(e) => {
                                                                // const today = new Date().toISOString().split('T')[0];
                                                                // const selectedDate = e.target.value;
                                                                // if (selectedDate <= today) {
                                                                    setExportClearance((prev) => {
                                                                        const updatedDocumentList = [...prev];
                                                                        updatedDocumentList[i][index].value = e.target.value
                                                                        return updatedDocumentList
                                                                    })
                                                                // } else {
                                                                //     configStore.setModalMessage("Enter a valid date")
                                                                // }
                                                            }}
                                                        />
                                                        {/* {icegateData && e.label === "Shipping Bill Checklist"?icegateData?.fullDate:null} */}
                                                        </>
                                                    )}
                                                        </>
                                                    }
                                                </td>}</>
                                            ))}
                                        </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-container" onClick={(e) => e.stopPropagation()}>
                                <div style={{ paddingBottom: '20px', fontWeight: 'bold' }}> Import Clearance ({Utils.extractCountry(props.data?.booking?.contract?.finalPlaceOfDelivery)})</div>
                                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                                    <thead>
                                        <tr>
                                            {importClearance?.map((e) => <th>{e.label}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {importClearance?.map((e, index) => (
                                                <td key={index}>
                                                    {index === 1 ? (
                                                        <input
                                                            className="input is-normal"
                                                            type="text"
                                                            disabled={(icegateData && e.label === "Bill of Entry Number")?true:props.disable}
                                                            value={icegateData && e.label === "Bill of Entry Number"?importClearance[index].value=icegateData.req.no:importClearance[index].value}
                                                            onChange={(e) => {
                                                                setImportClearance((prev) => {
                                                                    const updatedDocumentList = [...prev];
                                                                    updatedDocumentList[index].value = e.target.value
                                                                    return updatedDocumentList
                                                                })
                                                            }}
                                                        />
                                                    ) : (
                                                        <>
                                                        <input
                                                            className="input is-normal"
                                                            type="date"
                                                            max={Utils.dateConversion(new Date(), true)}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            disabled={icegateData && (e.label === "Bill of Entry Date"||e.label === "Out of Charge Date" ||e.label ===  "Bill of Entry Checklist")?true:props.disable}
                                                            value={
                                                                icegateData && e.label === "Bill of Entry Date"?importClearance[index].value =`${icegateData?.req?.date?.slice(4, 8)}-${icegateData?.req?.date?.slice(2, 4)}-${icegateData?.req?.date?.slice(0, 2)}`:
                                                                icegateData && e.label === "Bill of Entry Checklist"?importClearance[index].value=`${icegateData?.customerCompletedOn.replace(/\//g, '-').split('-').reverse().join('-')}`:
                                                                icegateData && e.label === "Out of Charge Date"?importClearance[index].value=`${icegateData?.res?.oocDt?.slice(4, 8)}-${icegateData?.res?.oocDt?.slice(2, 4)}-${icegateData?.res?.oocDt?.slice(0, 2)}`:importClearance[index].value
                                                            }
                                                            placeholder="Enter a Number"
                                                            onChange={(e) => {
                                                                // const today = new Date().toISOString().split('T')[0];
                                                                // const selectedDate = e.target.value;
                                                                // if (selectedDate <= today) {
                                                                    setImportClearance((prev) => {
                                                                        const updatedDocumentList = [...prev];
                                                                        updatedDocumentList[index].value = e.target.value
                                                                        return updatedDocumentList
                                                                    })
                                                                // } else {
                                                                //     configStore.setModalMessage("Enter a valid date")
                                                                // }
                                                            }}
                                                        />
                                                        {/* {icegateData && e.label === "Bill of Entry Checklist"?icegateData?.fullDate:null} */}
                                                       </>
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {!props.disable ? <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                {/* <button class="button is-danger" onClick={() => {
                                    setExportClearance(exportClearance)
                                    setImportClearance(importClearance)
                                    props.close()
                                }}>Cancel</button> */}
                                <button type="submit" class="button is-primary" onClick={onSubmit}>Submit</button>
                            </div> : <></>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}





